<template>

<form id="osForm" class="mx-auto col-sm-8 col-lg-12" @submit.prevent>

  <div class="row">
    <div class="form-group col-lg-4">
      <label for="services">{{ $t('services') }}</label>
      <Combobox
        class="bg-white"
        name='services'
        :placeholder="$t('select_a_item')"
        :hasErrors="errors.has('services')"
        label='name'
        :options="oss.serviceTypes"
        :reduce="serviceType => serviceType.id"
        :initial-value="os.service"
        v-model="os.service"
        v-validate="'required'"
      />

      <small v-show="errors.has('services')" class="form-text text-muted">
        {{ errors.first('services') }}
      </small>
    </div>

    <div class="form-group col-lg-8">
      <label for="contract">{{ $t('contract') }}</label>
      <Combobox
        class="bg-white"
        name='contract'
        :placeholder="$t('select_a_item')"
        :hasErrors="errors.has('contract')"
        :options="oss.contracts"
        :initial-value="os.contract"
        label="contracts"
        v-model="os.contract"
        :reduce="contract => contract.id_contrato"
        v-validate="'required'"
      />

      <small v-show="errors.has('contract')" class="form-text text-muted">
        {{ errors.first('contract') }}
      </small>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('board') }">
      <label for="board">{{ $t('board') }}</label>
      <input
        type="text"
        id="board"
        name="board"
        class="form-control"
        :disabled="!os.service || (os.service === 1 && !os.contract)"
        :placeholder="$t('ph_board')"
        :value="os.board"
        @input="event => {
          os.board = event.target.value.toUpperCase()
          searchDataBoardOrSerial('board')
        }"
        v-validate="'required|max:8|regex:[A-Z]{3}-{1}[0-9]{1}[0-9A-Z]{1}[0-9]{2}'"
        maxlength="8"
      />

      <small v-show="errors.has('board')" class="form-text text-muted">
        {{ errors.first('board') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('brand') }">
      <label for="brand">{{ $t('brand') }}</label>
      <Combobox
        class="bg-white"
        name='brand'
        :placeholder="$t('select_a_item')"
        :options="oss.vehicleBrands"
        :initial-value="os.brand"
        label='name'
        v-model="os.brand"
        :reduce='vehicleBrand => vehicleBrand.id'
      />
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('model') }">
      <label for="model">{{ $t('model') }}</label>
      <input
        type="text"
        id="model"
        name="model"
        class="form-control"
        :placeholder="$t('ph_model')"
        v-model="os.model"
        @input="upper('model')"
      />
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('color') }">
      <label for="color">{{ $t('color') }}</label>
      <input
        type="text"
        id="color"
        name="color"
        class="form-control"
        :placeholder="$t('ph_color')"
        v-model="os.color"
        @input="upper('color')"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="year">{{ $t('year') }}</label>
      <Combobox
        class="bg-white"
        name='year'
        :placeholder="$t('select_a_item')"
        :options="years"
        :initial-value="os.year"
        v-model="os.year"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="vehicle_type">{{ $t('vehicle_type') }}</label>
      <Combobox
        disabled
        class="bg-white"
        name='vehicle_type'
        :placeholder="$t('select_a_item')"
        label='TPV_DSC'
        :options="vehicleTypesStatic"
        :reduce="vehicleType => vehicleType.TPV_COD"
        :initial-value="'T008'"
        v-model="os.vehicleType"
      />
    </div>
  </div>

  <div class="row mt-3">
    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('test_date') }">
      <label for="test_date">{{ $t('service_date') }}</label>
      <input
        type="date"
        id="test_date"
        name="test_date"
        class="form-control"
        v-model="os.testDate"
        v-validate="'required'"
      />

      <small v-show="errors.has('test_date')" class="form-text text-muted">
        {{ errors.first('test_date') }}
      </small>
    </div>

    <div class="form-group col-lg-4" v-if="os.service === 1 && os.board.length === 8">
      <label for="vehicle_reuse">{{ $t('vehicle_reuse') }}</label>
      <Combobox
        class="bg-white"
        name='vehicle_reuse'
        :placeholder="$t('select_a_item')"
        :getOptionLabel="item => `${item.id_veiculo_maxfrota} / ${item.PLATE} / ${item.COMPANY ? item.COMPANY.toUpperCase() : ''} / ${item.MODEL ? item.MODEL.toUpperCase() : ''}`"
        :options="vehiclesToReuse"
        :reduce="vehicleReuse => vehicleReuse.id_veiculo_maxfrota"
        :initial-value="os.vehicleReuse"
        v-model="os.vehicleReuse"
      />
    </div>

    <div class="form-group col-lg-2">
      <LoaderButton
        @click="addVehicle"
        class="mt-4 p"
      >
        <i class="fas fa-plus" /> &nbsp;  Adicionar
      </LoaderButton>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-10 col-sm-4">
      <h3>OS's</h3>
    </div>
  </div>

  <div>
    <b-table
      class="bg-white"
      small
      :fields="fields"
      :items="vehicles"
      responsive="sm"
    >
      <template #cell(service)="data">
        {{ data.item.serviceName }}
      </template>

      <template #cell(contract)="data">
        {{ data.item.contractName }}
      </template>

      <template #cell(board)="data">
        {{ data.item.board }}
      </template>

      <template #cell(vehicledata)="data">
        {{ getVehicleDescription(data) }}
      </template>

      <template #cell(vehicleType)>
        SEM RASTREADOR
      </template>

      <template #cell(testDate)="data">
        {{ getDate(data) }}
      </template>

      <template #cell(vehicleReuse)="data">
        {{ data.item.vehicleReuse || '-' }}
      </template>

      <template #cell(action)="data">
        <button
          class="btn btn-sm btn-danger"
          @click="vehicles.splice(data.index, 1)"
          title="Limpar último posicionamento"
        >
          <i class="fas fa-times" />
        </button>
      </template>
    </b-table>
  </div>

  <div class="row mt-3">
    <div class="col-12 d-flex flex-row-reverse">
      <LoaderButton
        @click="onClick"
        :disabled="!vehicles.length"
      >
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>

  <div
    class="modal fade"
    id="modalConfirmContracts"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalConfirmContractsLabel"
    aria-hidden="true"
  >
    <div class="modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content bg-muted">

        <div class="modal-header">
          <h5 class="modal-title" id="modalConfirmContractsLabel">Confirmação</h5>

          <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div>
            <b-alert variant="warning" show>
              <h4 class="alert-heading">{{ $t('attention').toUpperCase() }}</h4>

              <p>Foi selecionado mais de 1 (um) contrato.</p>

              <hr>

              <h3 class="mb-0">Deseja confirmar mesmo assim?</h3>
            </b-alert>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary btn-form"
            data-dismiss='modal'
          >
            Não
          </button>

          <button
            type="button"
            class="btn btn-primary btn-form"
            @click='createOSs'
          >
            Sim
          </button>
        </div>

      </div>
    </div>
  </div>
</form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'
import years from '@/config/years.js'
import moment from 'moment'

const osDefault = {
  service: undefined,
  contract: undefined,
  board: '',
  brand: undefined,
  model: '',
  color: '',
  year: undefined,
  vehicleType: 'T008',
  testDate: moment().format('YYYY-MM-DD'),
  vehicleReuse: undefined
}

export default {
  name: 'OsSWForm',
  components: {
    LoaderButton,
    Combobox
  },
  data () {
    return {
      disabled: true,
      years,
      model: '',
      timeout: undefined,
      loading: false,
      vehicles: [],
      vehiclesSelected: [],
      vehicleTypesStatic: [
        { TPV_DSC: 'Sem Rastreador', TPV_COD: 'T008' }
      ],
      fields: [
        { key: 'contract', label: 'Contrato' },
        { key: 'board', label: 'Placa' },
        { key: 'vehicleData', label: 'Veículo' },
        { key: 'vehicleType', label: 'Tipo de Veículo' },
        { key: 'service', label: 'Serviço' },
        { key: 'testDate', label: 'Data Instalação/Retirada' },
        { key: 'vehicleReuse', label: 'Veículo a Reutilizar' },
        { key: 'action', label: '' }
      ],
      os: Object.assign({}, osDefault),
      vehiclesToReuseTemp: []
    }
  },
  
  computed: {
    ...mapState({
      oss        : state => state.ossw.all,
      vehicleData: state => state.ossw.vehicleData,
      vehiclesToReuse: state => state.ossw.vehiclesToReuse
    })
  },
  
  methods: {
    ...mapActions('ossw', [ 'create', 'edit', 'cleanState' ]),

    async createOSs() {
      $('#modalConfirmContracts').modal('hide')

      setTimeout(async () => {
        const created = await this.create(this.vehicles)
  
        if (created) {
          this.os = Object.assign({}, osDefault)
          this.vehicles = []
  
          return this.$router.push({ name: 'listossw' })
        }
      }, 500)
    },

    onClick () {
      const contractsIds = this.vehicles.map(vehicle => vehicle.contract)
      
      if ([...new Set(contractsIds)].length > 1) {
        return $('#modalConfirmContracts').modal('show')
      }

      this.createOSs()
    },

    // MOSTRA MENSAGEM DE ERRO
    hasError(message) {
      this.$store.dispatch('notify/error', { message: this.$t(message) }, { root: true })
    },

    // RETORNA DADOS DO VEÍCULO AO INSERIR A PLACA OU SERIAL
    async searchDataBoardOrSerial(search) {
      const { board } = this.os
      const { dispatch } = this.$store

      // Define máscara da placa
      if (window.event.inputType === 'deleteContentBackward') {
        return
      }
      if (board.length === 3){
        this.os.board = board + '-'
      }
      if (board.length === 4 && !board.includes('-')) {
        this.os.board = board.substr(0,3)+"-"+board.substr(3)
      }

      const stopTimeout = () => clearTimeout(this.timeout)

      const boardValid = /[A-Z]{3}-{1}[0-9]{1}[0-9A-Z]{1}[0-9]{2}/

      if (!boardValid.test(board) && board.length !== 8) {
        return stopTimeout()
      }

      const startTimeout = () => {
        dispatch('overlay/show', true)

        this.timeout = setTimeout(async () => {
          if (this.os.service === 1) {
            await dispatch('ossw/fetchVehiclesToReuse', {
              contract: this.os.contract,
              board: board.replace('-', '')
            })
  
            this.vehiclesToReuseTemp = this.vehiclesToReuse
          }
          
          await dispatch('ossw/fetchVehicleData', {
            board: board.replace('-', ''),
            service: this.os.service
          })

          if (Object.keys(this.vehicleData).length) {
            if (this.os.service === 1) {
              if (this.vehicleData.DISACTIVATE === 1) { // veículo inativo
                const brandId = this.oss.vehicleBrands.find(brand => brand.name === this.vehicleData.COMPANY.toUpperCase())
    
                this.os.brand = brandId && brandId.id
                this.os.model = this.vehicleData.MODEL.toUpperCase()
                this.os.color = this.vehicleData.COLOR.toUpperCase()
                this.os.year  = this.vehicleData.YEAR.toUpperCase()
              } else { // veículo ativo
                const boardTemp = this.os.board
                
                dispatch('notify/error', { message: `Veículo ${boardTemp} está ATIVO` }, { root: true })
  
                this.os.board = ''
                this.os.brand = undefined
                this.os.model = ''
                this.os.color = ''
                this.os.year = undefined
              }
            }

            if (this.os.service === 4) {
              if (this.vehicleData.DISACTIVATE === 1) { // veículo inativo
                const boardTemp = this.os.board
                
                dispatch('notify/error', { message: `Veículo ${boardTemp} está INATIVO` }, { root: true })
  
                this.os.board = ''
                this.os.brand = undefined
                this.os.model = ''
                this.os.color = ''
                this.os.year = undefined
              } else { // veículo ativo
                try {
                  this.os.contract = this.vehicleData.id_contrato
                  this.os.model    = this.vehicleData.MODEL.toUpperCase()
                  this.os.color    = this.vehicleData.COLOR.toUpperCase()
                  this.os.year     = this.vehicleData.YEAR.toUpperCase()

                  const brandId = this.oss.vehicleBrands.find(brand => brand.name === this.vehicleData.COMPANY.toUpperCase())
                  
                  this.os.brand = brandId && brandId.id
                } catch (error) {
                  console.log('[ERROR-GET-BRAND-ID] => ', error)
                }
              }
            }
          } else {
            if (this.os.service === 4) {
              const boardTemp = this.os.board
              dispatch('notify/error', { message: `Veículo ${boardTemp} não encontrado` }, { root: true })
              this.os.board = ''
            } else {
              this.os.brand = undefined
              this.os.model = ''
              this.os.color = ''
              this.os.year  = undefined
            }
          }

          dispatch('overlay/show', false)
        }, 1000)
      }

      stopTimeout()
      startTimeout()
    },

    upper(attribute) {
      this.os[attribute] = this.os[attribute].toUpperCase()
    },

    async addVehicle() {
      const isValid = await this.$validator.validateAll()

      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        
        return this.$store.dispatch('notify/error', err)
      }

      const exist = this.vehicles.find(vehicle => vehicle.board === this.os.board)

      if (exist) {
        return this.$store.dispatch('notify/error', { message: 'PLACA JÁ ADICIONADA!' }, { root: true })
      }

      const serviceName = this.oss.serviceTypes.find(service => service.id === this.os.service)
      const contractName = this.oss.contracts.find(contract => contract.id_contrato === this.os.contract)
      const brandName = this.oss.vehicleBrands.find(brand => brand.id === this.os.brand)
      
      this.os.serviceName = serviceName && serviceName.name
      this.os.contractName = contractName && contractName.contracts
      this.os.brandName = brandName && brandName.name

      if (this.os.service === 4) {
        this.os.id_veiculo_maxfrota = this.vehicleData.id_veiculo_maxfrota
      }

      this.vehicles.push(this.os)

      this.os = Object.assign({}, osDefault)
    },

    getVehicleDescription(data) {
      const {
        brandName,
        model,
        color,
        year
      } = data.item

      let result = [brandName, model, color, year].filter(item => item)

      return result.join('/') || '-'
    },

    getDate(date) {
      const { testDate } = date.item

      return moment(testDate).format('DD/MM/YYYY')
    },
  },

  async mounted () {
    const { dispatch } = this.$store

    dispatch('overlay/show', true)

    await dispatch('ossw/fetchAllPageOsSWForm')

    this.disabled = false

    dispatch('overlay/show', false)
  },

  destroyed () {
    this.cleanState()
  },
}
</script>